import { render, staticRenderFns } from "./exportDetailDataMo2.vue?vue&type=template&id=cd7931d2"
import script from "./exportDetailDataMo2.vue?vue&type=script&lang=js"
export * from "./exportDetailDataMo2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports